module.exports = __webpack_public_path__ + "static/media/2020_40k.d47fb477.png";